module.exports = __webpack_public_path__ + "static/media/27OCHA9.002e1c78.jpg";